/**
 * Miroir local des tutoriels marqués « vus en entier » (sync multi-onglets, aligné Centrale).
 * La source de vérité reste l’API ; ce stockage notifie les autres onglets via l’événement storage.
 */

export function fullViewStorageKey(userId) {
  return `tutorial_full_view_v1:${userId}`;
}

export function readStoredFullView(userId) {
  if (!userId) return {};
  try {
    const raw = localStorage.getItem(fullViewStorageKey(userId));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function mergeTutorialFullView(userId, tutorialId) {
  if (!userId || !tutorialId) return;
  try {
    const key = fullViewStorageKey(userId);
    const prev = readStoredFullView(userId);
    prev[tutorialId] = new Date().toISOString();
    localStorage.setItem(key, JSON.stringify(prev));
  } catch {
    /* quota / mode privé */
  }
}
